import React from "react";
import "@/App.css";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { FormProvider, useFormContext } from "./contexts/FormContext";
import { TooltipProvider } from "./components/ui/tooltip";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SongForm from "./components/SongForm";
import InfoSections from "./components/InfoSections";
import GuaranteesSection from "./components/GuaranteesSection";
import WaveDivider from "./components/WaveDivider";
// import ExamplesSection from "./components/ExamplesSection"; // Section supprimée
import VideoTestimonials from "./components/VideoTestimonials";
import TrustpilotReviews from "./components/TrustpilotReviews";
// import StreamingPlatforms from "./components/StreamingPlatforms"; // Section supprimée
import WhyUsSection from "./components/WhyUsSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LoadingScreen from "./components/LoadingScreen";
import Success from "./pages/Success";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ReturnRefundPolicy from "./components/ReturnRefundPolicy";
import { Toaster } from "./components/ui/toaster";

function HomePageContent() {
  const { currentStep } = useFormContext();
  
  // Quand on est à l'étape 2, masquer toutes les sections sauf le formulaire
  const showOnlyForm = currentStep === 2;

  return (
    <>
      <Header />
      <main>
        {!showOnlyForm && <Hero />}
        {!showOnlyForm && <VideoTestimonials />}
        {!showOnlyForm && <TrustpilotReviews />}
        {!showOnlyForm && <InfoSections />}
        <SongForm />
        {!showOnlyForm && <GuaranteesSection />}
        {/* <ExamplesSection /> - Section exemples de chansons supprimée */}
        {/* <StreamingPlatforms /> - Section "Find Your Song On" supprimée */}
        {!showOnlyForm && <WhyUsSection />}
        {!showOnlyForm && <FAQSection />}
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function HomePage() {
  return (
    <FormProvider>
      <HomePageContent />
    </FormProvider>
  );
}

// Preserves the current query string (?session_id=...) when redirecting
// legacy paths like /success → /en/success. Without this, Stripe's
// session_id is lost on redirect and Success.js cannot verify the payment.
function NavigateWithQuery({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <TooltipProvider>
          <LoadingScreen />
          <div className="App">
            <Routes>
              {/* Default route - redirect to /en */}
              <Route path="/" element={<Navigate to="/en" replace />} />
              
              {/* Language-specific routes */}
              <Route path="/:lang" element={<HomePage />} />
              <Route path="/:lang/success" element={<Success />} />
              <Route path="/:lang/terms" element={<TermsConditions />} />
              <Route path="/:lang/privacy" element={<PrivacyPolicy />} />
              <Route path="/:lang/refund" element={<ReturnRefundPolicy />} />
              
              {/* Legacy routes without language prefix - redirect to /en (preserving query string) */}
              <Route path="/success" element={<NavigateWithQuery to="/en/success" />} />
              <Route path="/terms" element={<NavigateWithQuery to="/en/terms" />} />
              <Route path="/privacy" element={<NavigateWithQuery to="/en/privacy" />} />
              <Route path="/refund" element={<NavigateWithQuery to="/en/refund" />} />
            </Routes>
            <Toaster />
          </div>
        </TooltipProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
